import { render, staticRenderFns } from "./InputWithSubvariables.vue?vue&type=template&id=64b227e4&scoped=true"
import script from "./InputWithSubvariables.vue?vue&type=script&lang=js"
export * from "./InputWithSubvariables.vue?vue&type=script&lang=js"
import style0 from "./InputWithSubvariables.vue?vue&type=style&index=0&id=64b227e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b227e4",
  null
  
)

export default component.exports